import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import { Platform, StatusBar } from 'react-native';

import useHeaderScreenOptions from 'app/hooks/useHeaderScreenOptions';
import { useI18n } from 'app/providers/I18nProvider';
import PastTripsScreen from 'app/screens/PastTripsScreen';
import PurchaseOrderDetailsScreen from 'app/screens/PurchaseOrderDetailsScreen';
import PurchasesScreen from 'app/screens/PurchasesScreen';

export type PurchasesStackParamList = {
  PurchasesList: undefined;
  PurchaseOrderDetails: {
    entitlementKey: string;
  };
  PastTrips: undefined;
};

const Stack = createNativeStackNavigator<PurchasesStackParamList>();

function applyPurchasesStatusBar() {
  // Light screens (white header): dark icons. Without this, Android's default / Product's
  // light-content leaves white icons on a white header — looks like a missing status bar
  // (common on BrowserStack and some AVDs when opening Purchases while logged out).
  StatusBar.setBarStyle('dark-content');
  if (Platform.OS === 'android') {
    StatusBar.setBackgroundColor('transparent');
    StatusBar.setTranslucent(true);
  }
}

export default function PurchasesStackNavigator() {
  const { t } = useI18n();
  const headerScreenOptions = useHeaderScreenOptions();

  return (
    <Stack.Navigator
      initialRouteName="PurchasesList"
      screenListeners={{
        focus: applyPurchasesStatusBar,
      }}
      screenOptions={{
        ...headerScreenOptions,
        headerStyle: {
          backgroundColor: 'white',
        },
      }}
    >
      <Stack.Screen
        component={PurchasesScreen}
        name="PurchasesList"
        options={{
          title: t<string>('app_menu_my_purchases'),
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        component={PurchaseOrderDetailsScreen}
        name="PurchaseOrderDetails"
        options={{
          title: t<string>('app_order_details_title'),
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        component={PastTripsScreen}
        name="PastTrips"
        options={{
          title: t<string>('app_purchases_past_trips'),
          headerTitleAlign: 'center',
        }}
      />
    </Stack.Navigator>
  );
}
